if (!window.fetch) window.fetch = require('unfetch').default || require('unfetch');



//////////////////
// WEBPACK FOOTER
// ./~/unfetch/polyfill.js
// module id = 85
// module chunks = 0